// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1uqUW","modalFooterButton":"ModalNotes_modalFooterButton__ppbMq"};